<div class="row search-bar-container">
  <div class="col-md-5 col-sm-12  col-xl-5 location-selector-container">
    <div class="item">
      <fa-icon [icon]="icons.search"></fa-icon>
    </div>
    <div class="item w-90">
      <app-location-selector [value]="searchValue" className="input-locator" placeholder="Enter Location"
        [showErrorMsg]="false" [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
        (inputValue)="locationInputChange($event)" (values)="locationChange($event)">
      </app-location-selector>
    </div>
  </div>
  <div class="col-md-7 col-sm-12 col-xl-7 d-flex align-items-center actions">
    <div class="col-md-5 col-sm-6 range-section px-3">
      <fa-icon class="icon-btn" (click)="dp.toggle()" [icon]="icons.calendar"></fa-icon>
      <input class="date-picker-input" type="text" placeholder="Check-in & Out" [minDate]="minDate"
        [bsConfig]="{ isAnimated: true, showWeekNumbers: false, rangeInputFormat: 'DD-MM-YYYY', dateInputFormat: 'ddd, MMMM Do', preventChangeToNextMonth: true }"
        [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChange($event)" #dp="bsDaterangepicker" bsDaterangepicker>
      <fa-icon class="icon-btn" (click)="dp.toggle()" [icon]="icons.caretDown"></fa-icon>
    </div>

    <form class="col-md-4 col-sm-6 guest-section" [formGroup]="form">
      <div data-bs-toggle="dropdown">
        <fa-icon [icon]="icons.users"></fa-icon>
        <input [formControlName]="'occupants'" class="guest-input" type="text" placeholder="Guests">
      </div>
      <ul class="dropdown-menu" (click)="$event.stopPropagation()">
        <div *ngFor="let occupant of occupant_types" class="d-flex justify-content-between align-items-center pb-3">
          <div class="d-flex align-items-center">
            <fa-icon class="dropdown-icon occupants-icon me-3" [icon]="occupant.icon"></fa-icon>
            <div>
              <h6 class="dropdown-text">{{occupant.name}}</h6>
              <small class="dropdown-subtext">{{occupant.subText}}</small>
            </div>
          </div>
          <div class="d-flex align-items-center">

            <fa-icon (click)="decrement(occupant.name)" class="dropdown-icon dropdown-caret" [icon]="icons.caretDown">
            </fa-icon>
            <input [formControlName]="occupant.name" (keyup)="constructString()" class="dropdown-input" type="number"
              placeholder="0">
            <fa-icon (click)="increment(occupant.name)" class="dropdown-icon dropdown-caret" [icon]="icons.caretUp">
            </fa-icon>
          </div>
        </div>
      </ul>
    </form>

    <!--
    <div class="col-md-3 col-sm-12 dropdown">
      <a class="btn  dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown"
        aria-expanded="false">
        {{searchRadius}} miles away
      </a>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
        <li *ngFor="let radius of miles">
          <a (click)="radiusChange(radius)" class="dropdown-item">{{radius}} miles</a>
        </li>

      </ul>
    </div> -->

    <!-- <div class="me-3 d-flex cur-pnt" (click)="openFilter()">
      <div class="me-2"><fa-icon [icon]="icons.sliderH"></fa-icon></div>
      <div class="me-2">Filter</div>
      <div><fa-icon [icon]="icons.caretDown"></fa-icon></div>
    </div> -->


    <div class="col-md-3 col-sm-12 search-button">
      <app-button [className]="'w-100'"
        [disabled]="!latlng || !dateRange || (form.controls['rooms'].value <1)  || (form.controls['adults'].value <1)"
        (onclick)="search()" warning>Search</app-button>
    </div>

  </div>
</div>

<!--ng-template #lpFilterModal>
  <app-lp-filter-modal
  [bsModalRef]="bsModalRef"
  [filter]="filter"
  (apply)="filterProperties($event)"  ></app-lp-filter-modal>
</ng-template>
<ng-template #lpFilterModal>
  <app-lp-filter-modal
  [bsModalRef]="bsModalRef"
  [filter]="filter"
  (apply)="filtertenants($event)"  ></app-lp-filter-modal>
</ng-template-->
